import fetch,{postFrom,getBlob} from '../utils/fetch';

// 有房提醒搜索条件查询
export function selectCondition() {
  return fetch({
    method: 'GET',
    url: 'idelHouseRemind/selectCondition',
  })
}

// 根据合同号查询合同
export function findContractInfoByCode(params) {
  return fetch({
    method: 'GET',
    url: 'contract/findContractInfoByCode',
    params
  })
}

// 有房提醒列表
export function getList(params) {
  return fetch({
    method: 'POST',
    url: 'idelHouseRemind/getList',
    data:params
  })
}

// 关闭有房提醒
export function closeRemind(params) {
  return fetch({
    method: 'POST',
    url: 'idelHouseRemind/closeHouseRemind',
    data:params
  })
}



